import React from 'react';
import { equipment } from '../utils/mockData';
import { Satellite, Compass, Scan, Radio, Plane, Monitor } from 'lucide-react';

const iconMap = {
  Satellite: Satellite,
  Compass: Compass,
  Scan: Scan,
  Radio: Radio,
  Plane: Plane,
  Monitor: Monitor
};

const Technology = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-50 text-blue-900 rounded-full text-sm font-semibold mb-4">
            Advanced Technology
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Advanced Surveying Technology
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            HBM Survey Projects uses modern surveying equipment and technology to ensure precise and reliable measurements.
          </p>
        </div>

        {/* Equipment Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {equipment.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="flex items-start gap-4 p-6 bg-gray-50 rounded-xl hover:bg-blue-50 transition-colors duration-300 group cursor-pointer hover:shadow-lg"
              >
                <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-blue-900 to-blue-700 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
                  <IconComponent className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-900 transition-colors">
                    {item.name}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-sm">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Technology;
